import { httpPostAsPromise } from '../../../pages/domestic/domesticAuthHttp';

export type AssumedUserRecord = {
  username: string;
  groups: string[];
  name?: string;
  orgName?: string;
  status?: string;
  lockReason?: string | null;
};

type AssumeResponse = {
  assumedUser?: AssumedUserRecord;
};

/**
 * POST URL_UserAssume. Resolves to responseData.assumedUser.
 * Rejects with the same wording Header used when the account has no groups.
 */
export function requestAssumeUser(
  email: string,
  user: object,
  options?: object,
): Promise<AssumedUserRecord> {
  const assumeUrl = (global as { URL_UserAssume?: string }).URL_UserAssume;
  return httpPostAsPromise(assumeUrl, { username: email }, user, options).then((responseData: AssumeResponse) => {
    const assumedUser = responseData && responseData.assumedUser;
    const groups = assumedUser && assumedUser.groups;
    if (!assumedUser || !assumedUser.username || !groups || groups.length === 0) {
      throw new Error(`No permission setup for this user , ${email}`);
    }
    return assumedUser;
  });
}
